export const BUS_TYPE = {
    prepare2fa: 'prepare2fa',
    set_breadcrumb_infro: 'set_breadcrumb_infro',
    pager: 'pager',
    updateValue: 'callAPIUpdate',
    change_2fa: 'change_2fa',
    set_active_slide:'set_active_slide',
    updateLocalValue: 'updateLocalValue'
}